import { AsyncPipe } from '@angular/common';
import { Component, ElementRef, HostListener } from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { finalize } from 'rxjs';
import { TranslatePipe } from '@core/i18n';
import { AuthService } from '@services/auth';
import { LanguageSwitcherComponent } from '../language-switcher/language-switcher.component';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [RouterLink, RouterLinkActive, AsyncPipe, TranslatePipe, LanguageSwitcherComponent],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent {
  readonly phone = '+1 (555) 123-4567';
  readonly phoneHref = 'tel:+15551234567';
  readonly navLinks = [
    { labelKey: 'nav.home', route: '/home' },
    { labelKey: 'nav.rooms', route: '/rooms' },
    { labelKey: 'nav.about', route: '/about' },
    { labelKey: 'nav.reviews', route: '/reviews' },
    { labelKey: 'nav.contact', route: '/contact' },
  ];

  isLoggingOut = false;
  isUserMenuOpen = false;

  readonly currentUser$ = this.authService.currentUser$;

  constructor(
    readonly authService: AuthService,
    private readonly router: Router,
    private readonly elementRef: ElementRef<HTMLElement>,
  ) {}

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (!this.elementRef.nativeElement.contains(event.target as Node)) {
      this.isUserMenuOpen = false;
    }
  }

  toggleUserMenu(event: Event): void {
    event.stopPropagation();
    this.isUserMenuOpen = !this.isUserMenuOpen;
  }

  closeUserMenu(): void {
    this.isUserMenuOpen = false;
  }

  getUserInitials(name: string): string {
    const parts = name.trim().split(/\s+/);

    if (parts.length >= 2) {
      return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
    }

    return name.trim().slice(0, 2).toUpperCase();
  }

  logout(): void {
    if (this.isLoggingOut) {
      return;
    }

    this.closeUserMenu();
    this.isLoggingOut = true;

    this.authService
      .logout()
      .pipe(finalize(() => (this.isLoggingOut = false)))
      .subscribe({
        next: () => {
          void this.router.navigate(['/login']);
        },
      });
  }
}
